class FamilySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.familySelector = this.querySelector('select[name="family-selector"]');
    this.handleChange = this.handleChange.bind(this);
    this.familySelector.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.familySelector.removeEventListener('change', this.handleChange);
  }

  handleChange(event) {
    const url = event.currentTarget.value;
    if (url) {
      window.location.assign(url);
    }
  }
}

customElements.define('family-selector', FamilySelector);
